(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["arc-product-voices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arc-review-carousel')) {
 customElements.define('arc-review-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const track = this.querySelector('.arc-product-voices__list');
   const previous = this.querySelector('[data-review-prev]');
   const next = this.querySelector('[data-review-next]');
   if (!track || !previous || !next) return;
   const signal = this.controller.signal;
   const update = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
   };
   const move = direction => {
    const slides = Array.from(track.children);
    const origin = slides[0]?.offsetLeft || 0;
    let current = 0;
    slides.forEach((slide, index) => {
     if (Math.abs(slide.offsetLeft - origin - track.scrollLeft) < Math.abs(slides[current].offsetLeft - origin - track.scrollLeft)) current = index;
    });
    const target = slides[Math.max(0, Math.min(slides.length - 1, current + direction))];
    if (target) track.scrollTo({left:target.offsetLeft - origin, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   track.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    move(event.key === 'ArrowRight' ? 1 : -1);
   }, {signal});
   previous.addEventListener('click', () => move(-1), {signal});
   next.addEventListener('click', () => move(1), {signal});
   track.addEventListener('scroll', update, {signal, passive:true});
   this.observer = new ResizeObserver(update);
   this.observer.observe(track);
   update();
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["arclab-size-popuplink"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arc-size-guide')) {
    customElements.define('arc-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const trigger = this.querySelector('[data-arc-open]');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        this.querySelectorAll('.arc-guide__content table').forEach((table) => {
          if (table.parentElement.classList.contains('arc-guide__table-wrap')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'arc-guide__table-wrap';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-labelledby', dialog.getAttribute('aria-labelledby'));
          table.before(wrapper);
          wrapper.append(table);
        });
        trigger.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          dialog.showModal();
        }, { signal });
        this.querySelectorAll('[data-arc-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close(), { signal });
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
            .filter((item) => item.tabIndex >= 0 && !item.disabled && item.getClientRects().length > 0);
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) { event.preventDefault(); return; }
          if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
            event.preventDefault(); first.focus();
          }
        }, { signal });
        const outside = (event) => {
          const rect = dialog.getBoundingClientRect();
          return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        };
        let startedOutside = false;
        dialog.addEventListener('pointerdown', (event) => { startedOutside = outside(event); }, { signal });
        dialog.addEventListener('click', (event) => { if (startedOutside && outside(event)) dialog.close(); startedOutside = false; }, { signal });
        dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({ preventScroll: true }); }, { signal });
      }
      disconnectedCallback() {
        this.querySelector('dialog[open]')?.close();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
